import { Icon } from '@iconify/react'

const DropdownBox = ({
  box,
  selectedFeatureIndex,
  classes,
  handleClose,
  handleDragStart,
  handleDoubleClick,
}) => {
  return (
    <div className={classes.dropdownContainer}>
      <div className={classes.dropdownHeader}>
        {box[selectedFeatureIndex].value === 'embed' ? (
          <span>Add Embeddable Block</span>
        ) : (
          <span>Add {box[selectedFeatureIndex].category} Block</span>
        )}
        <Icon
          onClick={handleClose}
          className={classes.icon}
          width="16"
          height="16"
          icon="ic:round-close"
        />
      </div>
      {box[selectedFeatureIndex].value === 'embed' ? (
        <div className={classes.optionsGrid}>
          {box[selectedFeatureIndex].options.map((option, index) => (
            <div className={classes.containerEmbed} key={index}>
              <div
                draggable
                onDragStart={handleDragStart(option)}
                onDoubleClick={() => handleDoubleClick(option)}
                className={classes.optionEmbedContainer}
              >
                {option.heading && (
                  <div className={classes.optionHeading}>{option.heading}</div>
                )}
                <div className={classes.optionText}>
                  <img
                    className={classes.imageEmbed}
                    src={option.image}
                    alt=""
                  />
                </div>
              </div>
              <div className={classes.optionTitleEmbed}>{option.name}</div>
            </div>
          ))}
        </div>
      ) : (
        <div>
          {box[selectedFeatureIndex].options.map((option, index) => (
            <div className={classes.container} key={index}>
              <div
                draggable
                onDragStart={handleDragStart(option)}
                onDoubleClick={() => handleDoubleClick(option)}
                className={classes.optionContainer}
              >
                {option.heading && (
                  <div className={classes.optionHeading}>{option.heading}</div>
                )}
                <div className={classes.optionText}>
                  <img className={classes.image} src={option.image} alt="" />
                </div>
              </div>
              <div className={classes.optionTitle}>{option.name}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default DropdownBox
